<template>
    <base-table-drawer
      ref="tableDrawer"
      handler="brandOrField"
      url="/get"
      :toolbar="toolbar"
      :columns="columns"
      :formItems="formItems"
      :beginAddBefor="beginAddBefor" 
      :rules="rules"
      :sendJson="true"
    ></base-table-drawer>
</template>
<script>
    export default {
        name:"brand-clum-manage",
        data(){
            var options=[];
            for(var i=11;i<=20;i++){
                options.push({
                    label:i,
                    value:i
                })
            }
            var baseFormItem={
                label: "列表类别",
                prop: "bid",
                component:"form-select1",
                bind:{
                    param:{
                        data_type:1
                    },
                    sendJson:true,
                    dataKey:{
                        label:'brand',
                        value:'id'
                    },
                },
                on:{
                    change:(obj)=>{
                        this.$nextTick(()=>{
                            this.drawer.$refs.drawer.form.brand=obj.lab;
                        })
                    }
                }
            }
            return {
                userArr:[],
                baseFormItem:baseFormItem,
                formItems:[
                    {
                        label: "查询类型",
                        prop: "type",
                        component: 'form-select1',
                        bind:{
                            options:this.$getOptions("queryType")
                        },
                        on:{
                            change:this.formTypeChange
                        }
                    },
                    // {
                    //     label: "语言",
                    //     prop: "lang",
                        
                    // },
                    // {
                    //     label: "品牌",
                    //     prop: "bid",
                    //     component:"form-select1",
                    //     bind:{
					// 		param:{
                    //             data_type:1
                    //         },
                    //         sendJson:true,
					// 		dataKey:{
					// 			label:'brand',
					// 			value:'id'
					// 		},
                    //     },
                    //     on:{
                    //         change:(obj)=>{
                    //             this.$nextTick(()=>{
                    //                 this.drawer.$refs.drawer.form.brand=obj.lab;
                    //             })
                    //         }
                    //     }
                    // },
                    baseFormItem,
                    // {
                    {
                        label: "列名称",
                        prop: "clum_desc",
                    },
                    {
                        label: "是否为查询列",
                        prop: "query_clum",
                        component: 'el-switch',
                        bind: {
                            activeValue: true,
                            inactiveValue: false,
                            // activeText:'是',
                            // inactiveText:'否',
                        },
                        on:{
                            change:this.updSortVal
                        }
                        
                    },
                    {
                        label: "排序值",
                        prop: "clum_sort",
                        component: 'form-select',
                        bind:{
                            options:options
                        },
                    },
                    
                ],
                rules:{
                    name:[{
                        required: true,
                        message: '请输入品牌名称',
                        trigger: 'blur',
                    },],
                    code:[{
                        required: true,
                        message: '请输入品牌代码',
                        trigger: 'blur',
                    },]
                },
                toolbar: {
                    formItems: [
                    {
                        label: "查询类型",
                        prop: "type",
                        component: 'form-select',
                        bind:{
                            options:this.$getOptions("queryType")
                        },
                        on:{
                            change:this.queryTypeChange
                        }
                    },
                    baseFormItem,
                    ],
                    query: {
                        // SortFields: [
                        //     {
                        //     Field: "Name",
                        //     Order: 1,
                        //     },
                        // ],
                        data_type: 2,
                    },
                    exButtons:[
                        // {
                        //     label: '导出查询结果',
                        //     on: { click: this.exportResult },
                        //     bind: { 
                        //     icon: '', 
                        //     style:'position: absolute;right: 120px;',
                        //     type: 'primary' 
                        //     },
                        // },
                    ],
                },
                columns: [
                    {
                        bind: {
                            label: "查询类型",
                            prop: "type",
                        },
                        default: {
                            component: "cell-text",
                            bind: {
                                formatter(scope, cellValue) {
                                    return this.$store.state.queryType[cellValue] || "";
                                },
                            },
                        },
                    },
                    // {
                    //     bind: {
                    //         label: "语言",
                    //         prop: "lang",
                    //     },
                    // },
                    {
                        bind: {
                            label: "品牌",
                            prop: "brand",
                        },
                    },
                    {
                        bind: {
                            label: "列代码",
                            prop: "clum_name",
                        },
                    },
                     {
                        bind: {
                            label: "列描述",
                            prop: "clum_desc",
                        },
                    },
                    {
                        bind: {
                            label: "是否查询列",
                            prop: "query_clum",
                        },
                        default: {
                            component: "cell-text",
                            bind: {
                                formatter(scope, cellValue) {
                                    return cellValue?"是":"否";
                                },
                            },
                        },
                    },
                    {
                        bind: {
                            label: "排序值",
                            prop: "clum_sort",
                        },
                    },
                    {
                        bind: {
                            label: "创建人",
                            prop: "cre_user",
                        },
                    },
                    {
                        bind: {
                            label: "创建时间",
                            prop: "cre_time",
                        },
                    },
                    {
                        rightbar:true,
                        bind: {
                            label: '操作',
                            prop: 'oper',
                            width: 120,
                        },
                        header: {
                            component: 'cell-button',
                            bind: { label: '新建', icon: 'el-icon-plus', type: 'primary' },
                            on: {
                                click: () => {
                                    this.drawer.beginAdd();
                                    this.$nextTick(()=>{
                                        this.formItems[0].bind.disabled=false;
                                        this.formItems[1].bind.disabled=false;
                                        this.formItems[1].prop="bid";
                                        this.formItems[2].bind.disabled=false;
                                        this.updSortVal(false);
                                    })
                                },
                            },
                        },
                        default:{
                            component: 'CellDropdown',
                            bind: {
                                dropdowns: [{
                                    label: '修改',
                                    click: (scope) => {
                                      
                                        this.drawer.beginEdit(scope);
                                        this.$nextTick(()=>{
                                            this.formItems[0].bind.disabled=true;
                                            this.formItems[1].bind.disabled=true;
                                            this.formItems[1].prop="brand";
                                            this.formItems[2].bind.disabled=true; 
                                            this.updSortVal(scope.row.query_clum);
                                        })
                                    },
                                },{
                                    label: '删除',
                                    click: this.delData,
                                }]
                            }
                        }
                    }
                ],
            }
        },
        computed:{
            drawer(){
                return this.$refs.tableDrawer;
            }
        },
        methods:{
            updSortVal(val){
                var newOptions=[];
                var startNo=1;
                if(!val){
                    startNo=11
                }
                for(var i=startNo;i<=startNo+9;i++){
                    newOptions.push({
                        label:i,
                        value:i
                    })
                } 
                this.$nextTick(()=>{
                    this.formItems[this.formItems.length-1].bind.options=newOptions;
                })
            },
            beginAddBefor(callBack){
                var that=this;
                var obj={
                    cre_user:that.$root.getNickName(),
                    data_type:2,
                };
                callBack(obj);
            },
            refreshOption(val){
                var baseFormItemNew={...this.baseFormItem};
                baseFormItemNew.bind.url="/brandOrField/get";
                baseFormItemNew.bind.param.type=val;
                return baseFormItemNew;
            },
            formTypeChange(obj){
                var that=this;
                var baseFormItemNew=this.refreshOption(obj.val);
                this.formItems.splice(1,1);
                this.$nextTick(()=>{
                    this.formItems.splice(1,0,baseFormItemNew);
                    this.formItems[0].value=obj.val;
                })
            },
            queryTypeChange(objVal){
                var that=this;
                var baseFormItemNew=this.refreshOption(objVal);
                baseFormItemNew.on={};
                this.toolbar.formItems.splice(1,1);
                this.$nextTick(()=>{
                    this.toolbar.formItems.splice(1,0,baseFormItemNew);
                    this.toolbar.formItems[0].value=objVal;
                })
			},
            delData(scope) {
                if (confirm('确定删除列【' + scope.row.clum_name + '】?')) {
                    this.$postObj('/brandOrField/remove', scope.row)
                    .then((resp) => {
                        if (resp.data.code == 0) {
                        this.drawer.$refs.table.delRow(scope.row)
                        } else {
                        console.error(resp)
                        this.$message(
                            resp.data.msg || this.$getMsg(resp.data.code, '服务端处理失败')
                        )
                        }
                    })
                    .catch((error) => {
                        // 请求失败处理
                        console.error(error)
                        this.$message('请求发生错误！')
                    })
                }
            },
        }
    }
</script>